import { useSnackbar } from 'notistack';
import { useState } from 'react';

const usePaymentModal = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return {
    open,
    loading,
    setLoading,
    onOpen,
    onClose,
    enqueueSnackbar
  };
};

export default usePaymentModal;
